import React, { FC } from 'react';
import SearchPage from '@/Page/SearchPage/SearchPage';
import { SearchFilterProvider } from '@/Page/SearchPage/Context/FilterContext';
import CategoryProductsHeader from './Components/CategoryTitle';

interface ICategoryProductsPageProps {
  children?: React.ReactNode;
  initialOrderNum: number;
}

const CategoryProductsPage: FC<ICategoryProductsPageProps> = ({ initialOrderNum }) => {
  return (
    <React.Fragment>
      <SearchFilterProvider initialOrderNum={initialOrderNum}>
        <SearchPage renderHeader={(productsCount: number) => <CategoryProductsHeader />} logoClickReset={false} />
      </SearchFilterProvider>
    </React.Fragment>
  );
};

export default CategoryProductsPage;
